import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ManifestForm.css'; // Custom CSS if needed

const ManifestForm = () => {
  const [formData, setFormData] = useState({
    manifestNo: '',
    manifestDate: '',
    manifestDest: '',
    vendor: '',
    forwardingNo: '',
    countNo: '',
    pkg: '',
    weight: '',
    remark: '',
    awbNo: '',
    bookDt: '',
    consignor: '',
    consignee: '',
    address: '',
    contactName: '',
    mode: '',
    destination: '',
    actWeight: '',
    qty: '',
    status: '',
    delivDt: '',
    sign: '',
    stamp: '',
    receivName: '',
  });

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    console.log('Submitted:', formData);
  };

  return (
    <div className="container mt-4 p-4 bg-light border rounded-4 shadow-sm">
      <div className="p-3 border rounded-4 mb-4 bg-white">
        <h5 className="text-primary">Manifest Details</h5>
        <div className="row g-2">
          <div className="col-md-2">
            <input name="manifestNo" value={formData.manifestNo} onChange={handleChange} placeholder="Manifest No" className="form-control" />
          </div>
          <div className="col-md-2">
            <input type="date" name="manifestDate" value={formData.manifestDate} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="manifestDest" value={formData.manifestDest} onChange={handleChange} placeholder="Manifest Dest" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="vendor" value={formData.vendor} onChange={handleChange} placeholder="Vendor" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="forwardingNo" value={formData.forwardingNo} onChange={handleChange} placeholder="Forwarding No" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="countNo" value={formData.countNo} onChange={handleChange} placeholder="Count No" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="pkg" value={formData.pkg} onChange={handleChange} placeholder="PKG" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="weight" value={formData.weight} onChange={handleChange} placeholder="Weight" className="form-control" />
          </div>
          <div className="col-md-6">
            <input name="remark" value={formData.remark} onChange={handleChange} placeholder="Remark" className="form-control" />
          </div>
        </div>
      </div>

      <div className="p-3 border rounded-4 mb-4 bg-white">
        <h5 className="text-primary">C.Note Details</h5>
        <div className="row g-2">
          <div className="col-md-2">
            <input name="awbNo" value={formData.awbNo} onChange={handleChange} placeholder="AWB No" className="form-control" />
          </div>
          <div className="col-md-2">
            <input type="date" name="bookDt" value={formData.bookDt} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-3">
            <input name="consignor" value={formData.consignor} onChange={handleChange} placeholder="Consignor" className="form-control" />
          </div>
          <div className="col-md-3">
            <input name="consignee" value={formData.consignee} onChange={handleChange} placeholder="Consignee" className="form-control" />
          </div>
          <div className="col-md-6">
            <input name="address" value={formData.address} onChange={handleChange} placeholder="Address" className="form-control" />
          </div>
          <div className="col-md-3">
            <input name="contactName" value={formData.contactName} onChange={handleChange} placeholder="Contact Name" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="mode" value={formData.mode} onChange={handleChange} placeholder="Mode" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="destination" value={formData.destination} onChange={handleChange} placeholder="Destination" className="form-control" />
          </div>
          <div className="col-md-2">
            <input name="actWeight" value={formData.actWeight} onChange={handleChange} placeholder="Act. Weight" className="form-control" />
          </div>
          <div className="col-md-1">
            <input name="qty" value={formData.qty} onChange={handleChange} placeholder="Qty" className="form-control" />
          </div>
        </div>
      </div>

      <div className="p-3 border rounded-4 mb-4 bg-white">
        <h5 className="text-success">POD Details</h5>
        <div className="row g-2">
          <div className="col-md-2">
            <select name="status" value={formData.status} onChange={handleChange} className="form-control">
              <option value="">Status</option>
              <option value="InTransit">InTransit</option>
              <option value="Delivered">Delivered</option>
            </select>
          </div>
          <div className="col-md-2">
            <input type="date" name="delivDt" value={formData.delivDt} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-2">
            <select name="sign" value={formData.sign} onChange={handleChange} className="form-control">
              <option value="">Sign</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div className="col-md-2">
            <input name="stamp" value={formData.stamp} onChange={handleChange} placeholder="Stamp" className="form-control" />
          </div>
          <div className="col-md-4">
            <input name="receivName" value={formData.receivName} onChange={handleChange} placeholder="Receiver Name" className="form-control" />
          </div>
        </div>
      </div>

      <div className="text-end">
        <button className="btn btn-success me-2" onClick={handleSubmit}>OK</button>
        <button className="btn btn-secondary">Cancel</button>
      </div>
    </div>
  );
};

export default ManifestForm;
